import { useState } from "react";
import { Image, Skeleton } from "antd";
import { isVideoAsset } from "./utils";
import { getMediaStyle } from "./mediaStyles";
import { FALLBACK_IMAGE } from "./constants";
import { radius } from "@libertify/ui";

interface MediaElementProps {
  src: string;
  width: number;
  height: number;
  borderRadius?: number;
  className?: string;
  assetPath?: string;
}

export const MediaElement = ({
  src,
  width,
  height,
  borderRadius = radius.box,
  className,
  assetPath,
}: MediaElementProps) => {
  const [loaded, setLoaded] = useState(false);
  const isVideo = isVideoAsset(assetPath || src);

  if (isVideo) {
    return (
      <video
        src={src}
        width={width}
        height={height}
        autoPlay
        muted
        loop
        controls={false}
        className={className}
        onCanPlay={() => setLoaded(true)}
        style={getMediaStyle(loaded, borderRadius)}
      />
    );
  }

  return (
    <Image
      src={src}
      width={width}
      height={height}
      preview={false}
      fallback={FALLBACK_IMAGE}
      className={className}
      placeholder={
        <Skeleton.Image active style={{ width, height, borderRadius }} />
      }
      onLoad={() => setLoaded(true)}
      style={getMediaStyle(loaded, borderRadius)}
    />
  );
};
